'use es6';

import { RECEIVED_VARIATIONS, REQUESTED_VARIATIONS_FAILED, REQUESTED_CONTENT, REQUESTED_VARIATIONS } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
import Variations from '../models/Variations';
export default ((state = new Variations(), action) => {
  switch (action.type) {
    case REQUESTED_VARIATIONS:
      return state.set('status', RequestStatus.PENDING);
    case RECEIVED_VARIATIONS:
      return action.payload.variations;
    case REQUESTED_VARIATIONS_FAILED:
      return state.set('status', RequestStatus.FAILED);
    case REQUESTED_CONTENT:
      return new Variations();
    default:
      return state;
  }
});